import { h } from 'preact';

const Calendar = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M13 14H3c-.551 0-1-.449-1-1V7h12v6c0 .551-.449 1-1 1zM3 3h1v.5a.5.5 0 0 0 1 0V3h6v.5a.5.5 0 0 0 1 0V3h1c.551 0 1 .449 1 1v2H2V4c0-.551.449-1 1-1zm10-1h-1v-.5a.5.5 0 0 0-1 0V2H5v-.5a.5.5 0 0 0-1 0V2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" fill-rule="evenodd" clip-rule="evenodd" />
		</svg>
	);
};

export default Calendar;
